import PropTypes from 'prop-types';

import { DefaultPartnerInfo, PartnerInfo } from './partner-info';

export const Partner = ({ partner, ...props }) =>
  partner.name ? <PartnerInfo {...props} {...partner} /> : <DefaultPartnerInfo {...props} />;

Partner.propTypes = {
  partner: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    photoUrl: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  partnerTitle: PropTypes.string,
  hidePartnerPrefix: PropTypes.bool,
  hidePartnerNameUnderline: PropTypes.bool,
  hidePartnerDescription: PropTypes.bool,
};
